import React from 'react';
import { IMAGE_BASE } from '../constants/site';
import './firstpage.css';

const FEATURED_ITEMS = [
  {
    image: `${IMAGE_BASE}/img15.jpg`,
    label: 'Traffic signals',
    title: 'Improving and repainting the road',
  },
  {
    image: `${IMAGE_BASE}/img16.jpg`,
    label: 'Traffic signals',
    title: 'Traffic light repair and complete equipment installation along major routes',
  },
  {
    image: `${IMAGE_BASE}/img08.jpg`,
    label: 'Safety areas',
    title: 'Workplace safety line marking for safer operations',
  },
  {
    image: `${IMAGE_BASE}/img17.jpg`,
    label: 'Road repair paint',
    title: 'Modern equipment for professional road painting',
  },
];

const BoxContentOne = () => (
  <div className="first-box">
    {FEATURED_ITEMS.map((item, index) => (
      <div key={item.title} className="first-box-content">
        <img src={item.image} alt={item.title} />
        <div className="first-content">
          <div className="apple">{item.label}</div>
          {index === 0 ? <h3>{item.title}</h3> : <h4>{item.title}</h4>}
        </div>
      </div>
    ))}
  </div>
);

export default BoxContentOne;
